import { render, staticRenderFns } from "./StakingGroup.vue?vue&type=template&id=f50d64ca&scoped=true"
import script from "./StakingGroup.vue?vue&type=script&lang=js"
export * from "./StakingGroup.vue?vue&type=script&lang=js"
import style0 from "./StakingGroup.vue?vue&type=style&index=0&id=f50d64ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f50d64ca",
  null
  
)

export default component.exports